// removed by extract-text-webpack-plugin
module.exports = {"mainholder":"mainholder__3N-Z3","symbol":"symbol__1-UdI","input":"input___4Cu4","converter-dropdownHolder":"converter-dropdownHolder__R-MxK","converter-inputflag":"converter-inputflag__3tZsP","converter-tooltip":"converter-tooltip__1x2Xv","converter-dropdown":"converter-dropdown__2RMxy","converter-searchContainer":"converter-searchContainer__--qlR","inputSearch":"inputSearch__37Zdw","searchItem":"searchItem__1VYxB","converter-currencyName":"converter-currencyName__2KBLZ","label-afterDropdown":"label-afterDropdown__3ylTy","flag-radius":"flag-radius__GP-e7"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Conversionfold/Converter/ConverterInput/ConverterInput.scss
// module id = 585
// module chunks = 68